import Alarm from "./Alarm";

export default class AlarmGps extends Alarm {
	constructor(data) {
		super(data);
	}
}
